// manageui v2 behaviors (backend dashboards)

// Filter selects submit their GET form on change (delegated: survives turbolinks)
$(document).on("change", ".js-toolbar-select", function () {
  this.form.submit()
})

// "/" focuses the global backend search unless already typing somewhere
$(document).on("keydown", function (e) {
  if (e.key !== "/" || e.ctrlKey || e.metaKey || e.altKey) return
  var tag = (e.target.tagName || "").toLowerCase()
  if (
    ["input", "textarea", "select"].indexOf(tag) !== -1 ||
    e.target.isContentEditable
  )
    return
  var $input = $(".search-dashboard input[name='query']").first()
  if ($input.length) {
    e.preventDefault()
    $input.focus()
  }
})
